import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AutoBindComponent from "../common/AutoBindComponent";
import unsavedDataDialogHandler from "../common/UnsavedDataDialogHandler";
import * as types from "../../constants/ComponentConstants";
import * as projectActions from "../../actions/projectActions";
import * as layoutActions from "../../actions/layoutActions";
import * as beads from "../../actions/beadActions";

import InfrastructuurDetailForm from "./InfrastructuurDetailForm";
import InfrastructuurDetailPageHelper from "./InfrastructuurDetailPageHelper";

import convertToLabelValuePair from "../../util/convertToLabelValuePair.js";

import EasterEggHandler from "../common/EasterEggHandler";
import * as pageConstants from "../../constants/EasterEggConstants";

class InfrastructuurDetailPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context);

        this.pageHelper = new InfrastructuurDetailPageHelper(this);
        this.easterEggHandler = new EasterEggHandler(this, pageConstants.INFRASTRUCTUURINDEBUURT);
    }

    componentWillReceiveProps(nextProps) {
    }

    componentWillMount() {
        this.pageHelper.init();
    }

    handleOnChange(event, data) {
        this.pageHelper.change(event, data);
    }

    handleOnSave(event) {
        this.pageHelper.save(event);
    }

    handleOnCancel(event) {
        this.pageHelper.cancel(event);
    }

    handleOnReplacePoint(event) {
        this.pageHelper.replacePoint(event);
    }

    handleOnDragEnd(e) {
        this.pageHelper.onDragEnd(e);
    }

    handleOnSaveNewPoint() {
        this.pageHelper.saveNewPoint();
    }

    handleOnCancelReplace() {
        this.pageHelper.cancelReplace();
    }

    handleOnGetGeoCoordinates(event) {
        this.pageHelper.getGeoCoordinates(event);
    }

    componentDidMount() {
        this.easterEggHandler.bind();
    }
    componentWillUnmount() {
        this.easterEggHandler.unbind();

    }

    render() {
        if (!this.pageHelper.isReadyToRender())
            return null;

        const {
            maxMapFeaturesToLoad,
            osmBaseLayerUrl
        } = this.props;

        return (<InfrastructuurDetailForm
            color={types.COLOR_PINK}
            model={this.state.model}
            isNew={this.props.isNew}
            isSpakki={this.state.isSpakki}
            soortenWerken={this.props.soortenWerken}
            soortenInfrastructuur={this.props.soortenInfrastructuur}
            gemeenten={this.props.gemeenten}
            postcodes={this.props.postcodes}
            mapKey={this.state.mapKey}
            mapEditMode={this.state.mapEditMode}
            onChange={this.handleOnChange}
            onSave={this.handleOnSave}
            onCancel={this.handleOnCancel}
            onReplacePoint={this.handleOnReplacePoint}
            mapNewCoords={this.state.mapNewCoords}
            onSaveNewPoint={this.handleOnSaveNewPoint}
            onCancelReplace={this.handleOnCancelReplace}
            onGetGeoCoordinates={this.handleOnGetGeoCoordinates}
            errors={this.props.infrastructuurErrors}
            databeheerderTelefoon={this.props.project.item.databeheerderTelefoon}
            databeheerderEmail={this.props.project.item.databeheerderEmail}
            maxMapFeaturesToLoad={maxMapFeaturesToLoad}
            osmBaseLayerUrl={osmBaseLayerUrl}
            onMarkerDragEnd={this.handleOnDragEnd}
        />);
    }
}

InfrastructuurDetailPage.propTypes = {
};

function mapStateToProps(state, ownProps) {
    const dossierId = ownProps.params.dossierId;
    const isNew = ownProps.route.params.isNew;
    const soortenInfrastructuur = !(state.project.item.andereInfrastructurenBeschikbaar === true || state.project.item.andereInfrastructurenBeschikbaar === "true") ? state.referentie.soortenInfrastructuur.filter((x, i) => i > 0) : state.referentie.soortenInfrastructuur;
    const type = ownProps.route.params.type;
    const sportinfrastructurenInDeBuurt = state.project.item.sportinfrastructurenInDeBuurt;

    return {
        dossierId: dossierId,
        postcodes: convertToLabelValuePair(state.referentie.postcodes),
        gemeenten: convertToLabelValuePair(state.referentie.gemeenten),
        soortenInfrastructuur: soortenInfrastructuur,
        project: state.project,
        sportinfrastructurenInDeBuurt: sportinfrastructurenInDeBuurt,
        infrastructuurErrors: state.project.infrastructuurErrors,
        validationMessageType: state.project.validationMessageType,
        soortenWerken: convertToLabelValuePair(state.referentie.soortenWerken),
        isNew: isNew,
        type: type,
        maxMapFeaturesToLoad: state.settings.maxMapFeaturesToLoad,
        osmBaseLayerUrl: state.settings.osmBaseLayerUrl
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadInfrastructuurDetailPageLayout, dispatch),
        beadsLoaded: bindActionCreators(beads.beadsLoaded, dispatch),
        getEmptyInfrastructuur: bindActionCreators(projectActions.getEmptyInfrastructuur, dispatch),
        saveInfrastructuur: bindActionCreators(projectActions.saveInfrastructuur, dispatch),
        resetInfrastructuurErrors: bindActionCreators(projectActions.resetInfrastructuurErrors, dispatch),
        removeInfrastructuur: bindActionCreators(projectActions.removeInfrastructuur, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(InfrastructuurDetailPage));